var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeoplecreatingrobotRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.92,319.954h-180.746c-3.232,0-5.862-2.63-5.862-5.862V50.819c0-3.232,2.63-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862V314.092c0,3.233-2.63,5.862-5.862,5.862ZM263.174,45.207c-3.095,0-5.612,2.518-5.612,5.612V314.092c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.517,5.612-5.612V50.819c0-3.094-2.518-5.612-5.612-5.612h-180.746Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.493,319.954H54.746c-3.232,0-5.862-2.63-5.862-5.862V50.819c0-3.232,2.629-5.862,5.862-5.862H235.493c3.232,0,5.862,2.629,5.862,5.862V314.092c0,3.233-2.63,5.862-5.862,5.862ZM54.746,45.207c-3.094,0-5.612,2.518-5.612,5.612V314.092c0,3.095,2.518,5.612,5.612,5.612H235.493c3.095,0,5.612-2.517,5.612-5.612V50.819c0-3.094-2.518-5.612-5.612-5.612H54.746Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 381.024,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.672,
    y: 395.288,
    width: 16.06,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.352,
    y: 392.578,
    width: 53.53,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.732,
    y: 404.578,
    width: 36.25,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.352,
    y: 392.448,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.452,
    y: 392.448,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.212,
    y: 398.678,
    width: 53.89,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 78.356,
    y: 85.556,
    width: 119.113,
    height: 131.806,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.597,
    y: 90.777,
    width: 108.943,
    height: 121.635,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.387 90.777 83.597 206.087 83.597 143.662 97.686 90.777 114.387 90.777",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.147 90.777 95.676 212.412 89.552 212.412 122.023 90.777 128.147 90.777",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.54 123.946 192.54 186.382 185.644 212.412 168.943 212.412 192.54 123.946",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.797,
    y: 85.556,
    width: 4.231,
    height: 131.806,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.424,
    y: 112.301,
    width: 114.76,
    height: 4.231,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 305.38,
    y: 86.044,
    width: 79.15,
    height: 62.486,
    rx: 4.936,
    ry: 4.936,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.006,86.044h69.977c2.509,0,4.546,2.037,4.546,4.546v6.35h-79.15v-6.269c0-2.554,2.073-4.627,4.627-4.627Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M380.333,92.287c0,1.314-1.065,2.378-2.379,2.378s-2.378-1.065-2.378-2.378,1.065-2.379,2.378-2.379,2.379,1.065,2.379,2.379Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.195,
    cy: 92.287,
    r: 2.378,
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.813,92.287c0,1.314-1.065,2.378-2.378,2.378s-2.378-1.065-2.378-2.378,1.065-2.379,2.378-2.379,2.378,1.065,2.378,2.379Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 106.049,
    width: 42.348,
    height: 2.218,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.208,
    y: 110.847,
    width: 30.301,
    height: 2.218,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.644,
    y: 106.049,
    width: 7.739,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.277,
    y: 106.049,
    width: 8.331,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 116.178,
    width: 42.348,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.644,
    y: 116.178,
    width: 7.739,
    height: 2.218,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.277,
    y: 116.178,
    width: 8.331,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 137.295,
    width: 42.348,
    height: 2.218,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.644,
    y: 137.295,
    width: 7.739,
    height: 2.218,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 121.519,
    width: 42.348,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.644,
    y: 121.519,
    width: 7.739,
    height: 2.218,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.277,
    y: 121.519,
    width: 8.331,
    height: 2.218,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.826,
    y: 110.935,
    width: 20.128,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 126.175,
    width: 30.301,
    height: 2.218,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.167,
    y: 126.262,
    width: 20.128,
    height: 2.218,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.548,
    y: 130.997,
    width: 15.151,
    height: 2.218,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,210.342c-1.462,2.226-2.444,4.671-2.968,7.193l-4.017,.378v7.779l4.017,.379c.523,2.521,1.506,4.966,2.968,7.193l-2.565,3.099,5.501,5.5,3.099-2.565c2.226,1.461,4.671,2.445,7.193,2.968l.378,4.017h7.779l.378-4.017c2.522-.524,4.967-1.507,7.193-2.968l3.099,2.565,5.5-5.501-2.565-3.099c1.461-2.226,2.444-4.671,2.968-7.193l4.016-.379v-7.779l-4.016-.379c-.524-2.521-1.507-4.966-2.969-7.192l2.565-3.099-5.5-5.5-3.099,2.565c-2.226-1.462-4.672-2.445-7.193-2.969l-.378-4.017h-7.779l-.378,4.017c-2.522,.524-4.967,1.506-7.193,2.968l-3.099-2.565-5.501,5.501,2.565,3.099Zm24.941,4.015c4.112,4.112,4.112,10.78,0,14.892-4.113,4.113-10.78,4.112-14.892,0-4.113-4.112-4.112-10.78,0-14.892,4.112-4.112,10.78-4.113,14.892,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.623,291.702c-1.338,2.037-2.237,4.274-2.716,6.582l-3.676,.346v7.118l3.676,.346c.479,2.307,1.379,4.545,2.716,6.582l-2.348,2.836,5.034,5.033,2.836-2.348c2.037,1.337,4.275,2.237,6.582,2.716l.346,3.676h7.118l.346-3.676c2.308-.479,4.545-1.379,6.582-2.716l2.836,2.348,5.033-5.033-2.347-2.836c1.337-2.037,2.237-4.274,2.716-6.582l3.675-.346v-7.118l-3.675-.346c-.479-2.307-1.379-4.545-2.717-6.582l2.348-2.836-5.033-5.033-2.836,2.348c-2.037-1.338-4.275-2.238-6.582-2.717l-.346-3.676h-7.118l-.346,3.676c-2.307,.479-4.545,1.379-6.582,2.716l-2.836-2.348-5.034,5.034,2.348,2.836Zm22.823,3.674c3.763,3.763,3.763,9.865,0,13.628-3.763,3.763-9.865,3.763-13.628,0-3.763-3.763-3.763-9.864,0-13.628,3.763-3.763,9.864-3.763,13.628,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.055,345.649c-1.097,1.67-1.834,3.505-2.228,5.398l-3.014,.284v5.837l3.014,.284c.392,1.892,1.13,3.727,2.227,5.397l-1.925,2.325,4.128,4.128,2.325-1.925c1.671,1.097,3.505,1.835,5.398,2.227l.284,3.014h5.837l.284-3.014c1.892-.393,3.727-1.131,5.398-2.228l2.325,1.925,4.128-4.128-1.925-2.325c1.097-1.671,1.834-3.505,2.227-5.397l3.014-.284v-5.837l-3.014-.284c-.393-1.892-1.131-3.727-2.228-5.397l1.925-2.325-4.128-4.128-2.325,1.925c-1.671-1.097-3.506-1.835-5.397-2.228l-.284-3.014h-5.837l-.284,3.014c-1.892,.393-3.727,1.13-5.397,2.227l-2.325-1.925-4.128,4.128,1.925,2.325Zm18.716,3.013c3.086,3.086,3.086,8.089,0,11.175-3.086,3.086-8.09,3.086-11.175,0s-3.086-8.089,0-11.175c3.086-3.086,8.089-3.086,11.175,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.552,318.436c-.81,1.234-1.354,2.588-1.645,3.986l-2.226,.21v4.31l2.226,.21c.29,1.397,.835,2.752,1.645,3.986l-1.422,1.717,3.048,3.048,1.717-1.422c1.234,.81,2.588,1.355,3.986,1.645l.21,2.226h4.31l.21-2.226c1.397-.29,2.752-.835,3.986-1.645l1.717,1.422,3.048-3.048-1.422-1.717c.81-1.234,1.355-2.588,1.645-3.986l2.226-.21v-4.31l-2.225-.21c-.29-1.397-.835-2.752-1.645-3.986l1.422-1.717-3.048-3.048-1.717,1.422c-1.234-.81-2.589-1.355-3.986-1.645l-.21-2.226h-4.31l-.21,2.226c-1.397,.29-2.752,.835-3.986,1.645l-1.717-1.422-3.048,3.048,1.422,1.717Zm13.821,2.225c2.279,2.279,2.279,5.974,0,8.252-2.279,2.279-5.974,2.279-8.252,0s-2.279-5.973,0-8.252c2.279-2.279,5.973-2.279,8.252,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,342.871c-.512,.78-.857,1.637-1.04,2.521l-1.407,.132v2.726l1.408,.133c.183,.883,.528,1.74,1.04,2.52l-.899,1.086,1.927,1.927,1.086-.899c.78,.512,1.637,.857,2.52,1.04l.133,1.408h2.726l.133-1.407c.884-.184,1.74-.528,2.52-1.04l1.086,.899,1.927-1.927-.899-1.086c.512-.78,.857-1.637,1.04-2.52l1.407-.133v-2.726l-1.407-.133c-.183-.883-.528-1.74-1.04-2.52l.899-1.086-1.927-1.927-1.086,.899c-.78-.512-1.637-.857-2.52-1.04l-.133-1.408h-2.726l-.133,1.408c-.883,.183-1.74,.528-2.52,1.04l-1.086-.899-1.927,1.927,.899,1.086Zm8.739,1.407c1.441,1.441,1.441,3.777,0,5.218s-3.777,1.441-5.218,0c-1.441-1.441-1.441-3.777,0-5.218,1.441-1.441,3.777-1.441,5.218,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.557,
    y: 54.936,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.868,
    y: 246.702,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.215,
    y: 251.743,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.373,
    y: 111.778,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.206,
    y: 89.02,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.62,
    y: 100.037,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112.654,
    y: 49.427,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.068,
    y: 60.445,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.774,
    y: 342.926,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.188,
    y: 353.944,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.127,
    y: 351.134,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.541,
    y: 362.151,
    width: 26.533,
    height: 11.018,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.323,442.262c0,3.387-93.516,6.132-208.875,6.132s-208.875-2.745-208.875-6.132,93.516-6.132,208.875-6.132,208.875,2.745,208.875,6.132Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.644,167.008c0,.798-.647,1.445-1.445,1.445s-1.445-.647-1.445-1.445,.647-1.445,1.445-1.445,1.445,.647,1.445,1.445Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.039,
    y: 166.508,
    width: 38.772,
    height: 1,
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.329,
    y: 131.863,
    width: 69.3,
    height: 58.274,
    rx: 4.936,
    ry: 4.936,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.329,
    y: 131.863,
    width: 69.3,
    height: 58.274,
    rx: 4.936,
    ry: 4.936,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.956,131.863h60.128c2.509,0,4.546,2.037,4.546,4.546v5.616h-69.3v-5.535c0-2.554,2.073-4.627,4.627-4.627Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.715,137.684c0,1.225-.993,2.218-2.218,2.218s-2.218-.993-2.218-2.218,.993-2.218,2.218-2.218,2.218,.993,2.218,2.218Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.411,137.684c0,1.225-.993,2.218-2.218,2.218s-2.218-.993-2.218-2.218,.993-2.218,2.218-2.218,2.218,.993,2.218,2.218Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.107,137.684c0,1.225-.993,2.218-2.218,2.218s-2.218-.993-2.218-2.218,.993-2.218,2.218-2.218,2.218,.993,2.218,2.218Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 150.519,
    width: 35.545,
    height: 2.068,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.478,
    y: 154.994,
    width: 25.434,
    height: 2.068,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.082,
    y: 150.519,
    width: 6.992,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.464,
    y: 150.519,
    width: 6.992,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 159.966,
    width: 35.545,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.082,
    y: 159.966,
    width: 6.992,
    height: 2.068,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.464,
    y: 159.966,
    width: 6.992,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 179.659,
    width: 35.545,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.082,
    y: 179.659,
    width: 6.992,
    height: 2.068,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 164.946,
    width: 35.545,
    height: 2.069,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.082,
    y: 164.946,
    width: 6.992,
    height: 2.069,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.464,
    y: 164.946,
    width: 6.992,
    height: 2.069,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.696,
    y: 155.075,
    width: 16.895,
    height: 2.069,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 169.289,
    width: 25.434,
    height: 2.068,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.142,
    y: 169.37,
    width: 16.895,
    height: 2.068,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.924,
    y: 173.786,
    width: 12.717,
    height: 2.068,
    style: {
      fill: "#263238",
      opacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 234.623,
    cy: 227.028,
    r: 10.12,
    transform: "translate(-59.448 368.844) rotate(-69.803)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.982,236.112c2.391,7.438,4.516,22.846,4.516,22.846-2.281,3.79-11.081,5.047-11.081,5.047,0,0-8.913-26.107-8.803-26.857,1.183-8.041,6.165-17.274,6.165-17.274,0,0,3.37-1.907,9.202,16.238Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.741,264.813s12.37,33.011,11.87,33.799-5.888,2.119-5.888,2.119c0,0-9.54-11.723-11.71-17.959-2.17-6.236-3.784-14.928-3.784-14.928l9.513-3.031Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.293,300.467c0,2.52-2.043,4.563-4.563,4.563s-4.563-2.043-4.563-4.563,2.043-4.563,4.563-4.563,4.563,2.043,4.563,4.563Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.93,
    cy: 263.621,
    r: 6.343,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.487,312.421c-.245-.478-1.334-10.158-.742-11.35,1.111-2.237,5.007-2.044,5.604-1.227s6.665,9.328,6.515,10.198c-.15,.871-1.032,8.844-3.011,9.8-1.979,.957-6.914,1.233-7.648-.201-.734-1.433-.717-7.221-.717-7.221Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 179.756,
    cy: 227.028,
    r: 10.12,
    transform: "translate(-82.373 350.082) rotate(-76.776)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.396,236.112c-2.391,7.438-4.516,22.846-4.516,22.846,2.281,3.79,11.081,5.047,11.081,5.047,0,0,8.913-26.107,8.803-26.857-1.183-8.041-6.165-17.274-6.165-17.274,0,0-3.37-1.907-9.203,16.238Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.637,264.813s-12.37,33.011-11.87,33.799,5.888,2.119,5.888,2.119c0,0,9.54-11.723,11.71-17.959s3.784-14.928,3.784-14.928l-9.513-3.031Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.359,301.154c0,2.52,2.043,4.563,4.563,4.563s4.563-2.043,4.563-4.563-2.043-4.563-4.563-4.563-4.563,2.043-4.563,4.563Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.365,262.94c0,3.503-2.84,6.343-6.343,6.343s-6.343-2.84-6.343-6.343,2.84-6.343,6.343-6.343,6.343,2.84,6.343,6.343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.629,314.297c.245-.478,1.334-10.158,.742-11.35-1.111-2.237-5.007-2.044-5.604-1.227-.597,.817-6.665,9.328-6.515,10.198,.15,.871,1.032,8.844,3.011,9.8,1.979,.956,6.914,1.233,7.648-.201s.717-7.221,.717-7.221Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.635,
    y: 256.596,
    width: 26.459,
    height: 23.435,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.157 216.909 180.416 236.526 190.89 266.424 224.909 266.424 233.773 236.526 233.255 216.909 180.157 216.909",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.347 285.44 191.1 275.495 226.252 275.495 232.551 285.854 213.967 306.301 202.439 306.301 184.347 285.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.715,273.762h0c0-1.38,1.119-2.499,2.499-2.499h33.371c1.38,0,2.499,1.119,2.499,2.499h0c0,1.38-1.119,2.499-2.499,2.499h-33.371c-1.38,0-2.499-1.119-2.499-2.499Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.449,
    cy: 239.522,
    r: 9.628,
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.449,
    cy: 239.522,
    r: 8.075,
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.821,
    y: 203.52,
    width: 17.703,
    height: 13.389,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.666,185.647c-3.965-21.033-24.557-21.958-27.849-21.97h0s-22.594-.904-26.907,21.97c-1.357,7.198,2.227,14.515,8.853,17.639,3.807,1.796,9.141,3.174,16.589,3.447v.045c.66,.009,1.303,.009,1.936,.002,.632,.007,1.276,.007,1.937-.002l-.002-.045c7.449-.273,12.783-1.651,16.591-3.447,6.625-3.125,10.21-10.441,8.853-17.639Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.609,183.776c-3.536-16.091-21.895-16.799-24.83-16.808h0s-20.145-.692-23.99,16.808c-1.21,5.507,1.986,11.105,7.893,13.495,3.395,1.374,8.15,2.428,14.791,2.637v.034c.589,.007,1.162,.007,1.726,.002,.564,.005,1.137,.006,1.727-.002l-.002-.034c6.642-.209,11.397-1.263,14.792-2.637,5.907-2.391,9.103-7.988,7.893-13.495Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.339,
    cy: 185.228,
    rx: 1.739,
    ry: 3.502,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.697,185.228c0,1.934-.778,3.502-1.739,3.502s-1.739-1.568-1.739-3.502,.778-3.502,1.739-3.502,1.739,1.568,1.739,3.502Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.658,187.71s24.17-11.363,30.039-20.161c0,0,2.729,.228,7.894,2.514,1.821,.806-23.063,22.934-34.776,23.942,0,0-3.133-3.248-3.157-6.295Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.786,199.458s15.814-17.708,16.823-15.683c.724,1.452,1.776,13.954-16.823,15.683Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.442,252.055c-6.968,0-12.638-5.669-12.638-12.638s5.669-12.638,12.638-12.638,12.638,5.669,12.638,12.638-5.669,12.638-12.638,12.638Zm0-24.776c-6.693,0-12.138,5.445-12.138,12.138s5.445,12.138,12.138,12.138,12.138-5.445,12.138-12.138-5.445-12.138-12.138-12.138Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.266,287.851c-.684,0-9.351,7.854-9.351,20.616s6.381,43.07,6.381,43.07h17.775v-46.286l-14.805-17.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.04,359.758s-6.809,10.895-3.404,42.31c1.933,17.839,5.137,26.302,5.137,26.302h11.717l1.288-68.311-14.739-.301Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.609,307.767h0c-1.043,.904-2.621,.792-3.526-.251l-16.109-18.576c-.904-1.043-.792-2.621,.251-3.526h0c1.043-.904,2.621-.792,3.526,.251l16.108,18.575c.904,1.043,.792,2.621-.251,3.526Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.632,363.197h0c-4.009,0-7.259-3.25-7.259-7.259h0c0-4.009,3.25-7.259,7.259-7.259h0c4.009,0,7.259,3.25,7.259,7.259h0c0,4.009-3.25,7.259-7.259,7.259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.632,438.835h0c-4.009,0-7.259-3.25-7.259-7.259h0c0-4.009,3.25-7.259,7.259-7.259h0c4.009,0,7.259,3.25,7.259,7.259h0c0,4.009-3.25,7.259-7.259,7.259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.372,438.835s4.722-13.01,13.259-12.243c8.537,.767,12.243,12.243,12.243,12.243h-25.503Z",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M233.451,287.756c.684,0,9.351,7.854,9.351,20.616s-6.381,43.07-6.381,43.07h-17.775v-46.286l14.805-17.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.678,359.663s7.124,11.584,1.486,43.584c-3.089,17.532-5.025,25.124-5.025,25.124h-11.717l.517-68.406,14.739-.301Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.444,308.461h0c-1.029-.92-1.118-2.5-.199-3.529l16.382-18.335c.92-1.029,2.5-1.118,3.529-.199h0c1.029,.92,1.118,2.5,.199,3.529l-16.381,18.335c-.92,1.029-2.5,1.118-3.529,.199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.086,363.102h0c4.009,0,7.259-3.25,7.259-7.259h0c0-4.009-3.25-7.259-7.259-7.259h0c-4.009,0-7.259,3.25-7.259,7.259h0c0,4.009,3.25,7.259,7.259,7.259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.462,438.835h0c4.009,0,7.259-3.25,7.259-7.259h0c0-4.009-3.25-7.259-7.259-7.259h0c-4.009,0-7.259,3.25-7.259,7.259h0c0,4.009,3.25,7.259,7.259,7.259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.832,438.835s4.722-13.01,13.259-12.243c8.537,.767,12.243,12.243,12.243,12.243h-25.503Z",
    style: {
      fill: "#407BFF"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot_Arm_2--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.565,295.921c-.962-6.935-4.594-13.432-10.095-17.79-5.743-4.55-13.242-6.583-20.499-5.682-.473,.059-.479,.809,0,.75,7.18-.891,14.647,1.109,20.274,5.708,5.247,4.288,8.667,10.515,9.597,17.213,.066,.476,.789,.273,.723-.199h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.173,
    y: 263.623,
    width: 4.525,
    height: 11.147,
    transform: "translate(-100.302 330.368) rotate(-51.484)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.236,
    y: 263.365,
    width: 13.27,
    height: 5.233,
    transform: "translate(-99.51 325.581) rotate(-51.483)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.864 246.973 273.406 249.066 278.843 249.148 284.53 254.377 283.993 260.406 281.568 263.453 275.813 265.329 269.441 260.96 268.142 255.68 265.98 255.621 266.287 263.628 275.097 269.965 284.742 267.276 286.539 264.921 288.431 262.641 288.887 252.639 280.735 245.476 272.864 246.973",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 297.151,
    y: 423.953,
    width: 93.315,
    height: 14.882,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.082,431.394l8.756-35.834c1.235-5.055,5.765-8.612,10.969-8.612h34.422c5.08,0,9.535,3.392,10.886,8.289l10.584,38.368-75.618-2.212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.344,418.629h0c-5.862,0-10.614-4.752-10.614-10.614v-57.745c0-5.862,4.752-10.614,10.614-10.614h0c5.862,0,10.614,4.752,10.614,10.614v57.745c0,5.862-4.752,10.614-10.614,10.614Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.344,418.629h0c-5.862,0-10.614-4.752-10.614-10.614v-57.745c0-5.862,4.752-10.614,10.614-10.614h0c5.862,0,10.614,4.752,10.614,10.614v57.745c0,5.862-4.752,10.614-10.614,10.614Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.957,352.736h0c-2.563,.499-5.044-1.175-5.543-3.737l-9.242-47.495c-.499-2.563,1.175-5.044,3.737-5.543h0c2.563-.499,5.044,1.175,5.543,3.737l9.242,47.495c.499,2.563-1.175,5.044-3.737,5.543Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.503,303.401h0c-1.57,2.086-4.533,2.505-6.62,.935l-38.662-29.094c-2.086-1.57-2.505-4.533-.935-6.62h0c1.57-2.086,4.533-2.505,6.62-.935l38.663,29.094c2.086,1.57,2.505,4.533,.935,6.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.503,303.401h0c-1.57,2.086-4.533,2.505-6.62,.935l-38.662-29.094c-2.086-1.57-2.505-4.533-.935-6.62h0c1.57-2.086,4.533-2.505,6.62-.935l38.663,29.094c2.086,1.57,2.505,4.533,.935,6.62Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.584,300.467c0,1.094-.886,1.98-1.98,1.98s-1.98-.887-1.98-1.98,.886-1.98,1.98-1.98,1.98,.887,1.98,1.98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.198,
    cy: 271.45,
    r: 1.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,347.357c0,1.094-.886,1.98-1.98,1.98s-1.98-.886-1.98-1.98,.886-1.98,1.98-1.98,1.98,.887,1.98,1.98Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.14,407.907c0,3.201-2.595,5.796-5.796,5.796s-5.796-2.595-5.796-5.796,2.595-5.796,5.796-5.796,5.796,2.595,5.796,5.796Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.231,309.289c-1.929,5.475-3.181,11.471-1.699,17.215,1.209,4.687,4.146,8.739,8.27,11.278,.412,.254,.789-.395,.379-.648-4.07-2.505-6.907-6.537-8.013-11.179-1.313-5.515-.06-11.23,1.786-16.466,.161-.456-.564-.652-.723-.199h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "308.9 423.953 380.036 423.953 379.26 421.138 309.588 421.138 308.9 423.953",
    style: {
      opacity: 0.3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot_Arm_1--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.621,190.623c.853-7.93,4.774-15.424,10.863-20.591,6.401-5.432,14.955-7.982,23.284-7.188,.48,.046,.477-.705,0-.75-13.404-1.278-26.442,6.119-32.096,18.357-1.488,3.221-2.421,6.646-2.801,10.172-.052,.479,.699,.476,.75,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.308,
    y: 151.35,
    width: 5.29,
    height: 13.031,
    transform: "translate(127.876 375.065) rotate(-130.218)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.418,
    y: 150.891,
    width: 15.513,
    height: 6.118,
    transform: "translate(139.458 372.61) rotate(-130.217)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.052 131.219 172.491 133.684 166.141 133.967 159.676 140.275 160.513 147.301 163.453 150.778 170.242 152.77 177.536 147.444 178.871 141.229 181.395 141.086 181.314 150.452 171.24 158.162 159.876 155.355 157.695 152.665 155.405 150.067 154.526 138.395 163.802 129.742 173.052 131.219",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.304,
    y: 421.438,
    width: 109.086,
    height: 17.397,
    transform: "translate(181.695 860.274) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.782,430.137l-10.235-41.89c-1.444-5.91-6.74-10.067-12.823-10.067h-40.24c-5.939,0-11.146,3.966-12.726,9.69l-12.373,44.853,88.398-2.586Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.526,413.07h0c6.414-2.411,9.66-9.565,7.249-15.979l-23.749-63.189c-2.411-6.414-9.565-9.66-15.979-7.249h0c-6.414,2.411-9.66,9.565-7.249,15.979l23.749,63.189c2.411,6.414,9.565,9.66,15.979,7.249Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.526,413.07h0c6.414-2.411,9.66-9.565,7.249-15.979l-23.749-63.189c-2.411-6.414-9.565-9.66-15.979-7.249h0c-6.414,2.411-9.66,9.565-7.249,15.979l23.749,63.189c2.411,6.414,9.565,9.66,15.979,7.249Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.003,347.899h0c6.412,2.417,13.569-.821,15.987-7.233l23.814-63.165c2.417-6.412-.821-13.569-7.233-15.987h0c-6.412-2.417-13.569,.821-15.987,7.233l-23.814,63.165c-2.417,6.412,.821,13.569,7.233,15.987Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.003,347.899h0c6.412,2.417,13.569-.821,15.987-7.233l23.814-63.165c2.417-6.412-.821-13.569-7.233-15.987h0c-6.412-2.417-13.569,.821-15.987,7.233l-23.814,63.165c-2.417,6.412,.821,13.569,7.233,15.987Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.802,274.627h0c3.012,.494,5.854-1.548,6.347-4.559l11.998-73.177c.494-3.012-1.547-5.854-4.559-6.347h0c-3.012-.494-5.854,1.547-6.347,4.559l-11.998,73.177c-.494,3.012,1.547,5.854,4.559,6.347Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.479,199.396h0c1.907,2.383,5.384,2.77,7.767,.863l44.168-35.336c2.383-1.907,2.769-5.384,.863-7.767h0c-1.907-2.383-5.384-2.769-7.767-.863l-44.168,35.336c-2.383,1.907-2.769,5.384-.863,7.767Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.479,199.396h0c1.907,2.383,5.384,2.77,7.767,.863l44.168-35.336c2.383-1.907,2.769-5.384,.863-7.767h0c-1.907-2.383-5.384-2.769-7.767-.863l-44.168,35.336c-2.383,1.907-2.769,5.384-.863,7.767Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.619,195.901c.038,1.278,1.104,2.283,2.382,2.245s2.283-1.104,2.245-2.382-1.104-2.283-2.382-2.245-2.283,1.105-2.245,2.382Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,160.664c.038,1.278,1.104,2.283,2.382,2.245,1.278-.038,2.283-1.105,2.245-2.382-.038-1.278-1.104-2.283-2.382-2.245s-2.283,1.105-2.245,2.382Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,268.382c-.207,1.262,.648,2.452,1.91,2.659,1.261,.207,2.452-.648,2.659-1.91,.207-1.262-.648-2.452-1.91-2.659-1.261-.207-2.452,.648-2.659,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.616,402.68c0,3.742,3.034,6.776,6.776,6.776s6.776-3.034,6.776-6.776-3.034-6.776-6.776-6.776-6.776,3.034-6.776,6.776Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.297,338.903c1.316,3.503,5.223,5.275,8.726,3.959,3.503-1.316,5.275-5.223,3.959-8.726-1.316-3.503-5.223-5.275-8.726-3.959-3.503,1.317-5.275,5.223-3.959,8.726Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.231,206.287c2.335,6.035,3.993,12.657,2.682,19.13-1.113,5.501-4.309,10.386-9.014,13.467-.402,.263-.027,.913,.379,.648,4.763-3.119,8.059-8.006,9.284-13.561,1.48-6.708-.181-13.61-2.607-19.883-.172-.445-.898-.252-.723,.199h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.657 421.438 48.498 421.438 49.405 418.147 130.852 418.147 131.657 421.438",
    style: {
      opacity: 0.3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.509,161.669c3.077-8.438-1.269-17.773-9.707-20.85s-17.773,1.269-20.85,9.707c-2.375,6.514-.314,13.55,4.626,17.842l.067,4.884,4.765-1.981c.085,.032,.163,.074,.248,.105,8.438,3.077,17.773-1.269,20.85-9.707Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.143,152.883c-.127,0-.235-.095-.249-.224-.541-5.155-3.887-9.984-8.522-12.302-.124-.062-.174-.212-.112-.335,.062-.124,.215-.173,.335-.112,4.785,2.393,8.238,7.376,8.798,12.697,.014,.138-.086,.261-.223,.275h-.026Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.245,157.705c-.019,0-.038-.002-.058-.007-.135-.032-.218-.167-.186-.301,.178-.748,.199-1.543,.062-2.299-.024-.136,.065-.266,.201-.291,.142-.025,.267,.065,.291,.202,.148,.823,.125,1.689-.068,2.503-.027,.115-.13,.192-.243,.192Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "430.972 163.226 423.518 157.676 425.455 155.075 430.453 158.797 437.32 150.604 439.806 152.687 430.972 163.226",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.032,213.4c-6.122,6.403-10.165,22.614-10.7,23.001-1.968,1.423-18.123-14.143-18.123-14.143l-6.108,7.42s7.294,7.987,15.693,16.01c8.667,8.278,12.904,9.072,17.483,2.485,4.197-6.036,13.859-26.946,13.859-26.946l-12.104-7.826Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.032,213.4c-6.122,6.403-10.165,22.614-10.7,23.001-1.968,1.423-18.123-14.143-18.123-14.143l-6.108,7.42s7.294,7.987,15.693,16.01c8.667,8.278,12.904,9.072,17.483,2.485,4.197-6.036,13.859-26.946,13.859-26.946l-12.104-7.826Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.053,224.919s.843-2.576-.193-4.564c-1.036-1.988-1.335-3.85-2.208-5.275s-1.238,.8-1.193,2.023c.045,1.223,.084,2.609-.84,2.495-.924-.114-7.328-4.923-8.627-4.936-1.299-.013-.507,1.088-.507,1.088,0,0-1.587-1.126-2.204-.619-.16,.132-.319,.698,.323,1.325,1.446,1.409,4.632,4.21,4.632,4.21-.18-.164-4.36-3.341-5.048-3.735-.899-.515-1.586-.299-1.868,.232-.401,.756,4.648,4.872,4.739,5.194,0,0-3.726-1.903-4.762-1.522-1.036,.381,1.415,1.781,3.186,2.952,1.623,1.073,4.669,3.29,6.425,4.221,2.164,1.147,3.875,1.431,5.693,.029,1.819-1.403,2.449-3.119,2.449-3.119Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.505,225.182c-.027,0-.056-.009-.079-.028-.656-.531-1.128-1.311-1.294-2.137-.167-.827-.033-1.728,.366-2.472,.033-.062,.108-.083,.17-.051,.061,.032,.083,.108,.051,.169-.373,.693-.498,1.533-.343,2.304,.155,.771,.596,1.498,1.208,1.993,.053,.043,.062,.122,.018,.176-.024,.031-.061,.046-.097,.046Z",
    style: {
      opacity: 0.3
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.872,352.742l.698,73.811,.261,7.708,5.649-.319,2.194-13.449s6.481-25.579,7.859-48.644c.311-5.313-.95-11.508-.361-15.702,.513-3.682,1.967-5.985,4.026-14.29,2.48-10.087,5.043-23.587,4.413-34.111,0,0,10.793-11.272,8.027-26.638l-28.143-7.481-4.623,79.116Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.657,441.395c1.122-.667,2.394-1.173,3.755-1.494h0s4.086-2.975,6.2-12.069l5.317-.98c1.827-.3,3.71,.284,4.733,1.47,.142,.167,.253,.348,.331,.538,.242,.968,.405,1.945,.489,2.928,.218,3.341,.176,6.688-.126,10.025h-.994l-.237-6.297c0-2.139-2.319,.347-2.982,2.629-.663,2.282-2.035,4.78-8.22,4.78-7.116,.024-10.113-.215-8.267-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.622,424.571s-1.199,4.158-3.155,8.759c-.805,2.37-2.203,4.601-4.118,6.572,0,0,4.623,.681,6.674-1.649,2.051-2.33,4.954-10.36,9.64-9.882-.352-.596-1.554-2.006-2.083-2.521-.757-.849-6.958-1.279-6.958-1.279Z",
    style: {
      fill: "#ffaf6b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.726,277.653l18.157,77.191,20.37,67.757,7.821-2.371s-1.511-29.358-6.782-51.86c-1.21-5.186-4.203-10.76-4.825-14.954-.563-3.673,.185-6.296-.235-14.87-.496-10.364-1.875-24.058-5.506-33.943,0,0,7.128-13.887,.101-27.823l-29.101,.874Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.327,440.892c.787-1.041,1.774-1.99,2.913-2.801h0s2.66-4.298,1.184-13.517l4.553-2.915c1.579-.968,3.543-1.138,4.938-.426,.194,.101,.366,.227,.51,.373,.589,.805,1.109,1.648,1.558,2.526,1.464,3.011,2.689,6.127,3.669,9.331l-.92,.375-2.597-5.742c-.808-1.981-2.017,1.197-1.769,3.56,.248,2.363-.08,5.194-5.807,7.53-6.58,2.709-9.446,3.619-8.233,1.705Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.127,421.173s.46,4.303,.385,9.302c.15,2.498-.302,5.092-1.331,7.64,0,0,4.538-1.115,5.557-4.047,1.019-2.932,.676-11.464,5.195-12.79-.551-.419-1.175-.771-1.859-1.049-1.022-.5-7.947,.944-7.947,.944Z",
    style: {
      fill: "#ffaf6b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.745,337.043v1.16s17.989,4.901,29.9,4.934,31.127-4.606,31.127-4.606c0,0,.157-39.06-5.934-55.789-6.067-16.662-13.875-24.105-13.875-24.105l-32.356,7.915c-3.097,6.735-4.333,20.451-5.414,34.749-1.981,11.819-3.132,23.762-3.446,35.742Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.019,220.424c-.923,1.576-1.239,2.474-1.818,4.29-.578,1.816-.896,5.119-1.039,6.825l3.117,.898c-.121-4.166-.139-7.847-.26-12.013Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.751,232.829l4.448-17.485c-3.244-4.841-18.614-8.561-18.614-8.561l-10.574,.578s-4.064,.907-7.544,2.042c-4.645,1.515-7.157,2.733-8.265,5.311,0,0-1.938,5.711-.773,17.479,.32,3.236,1.053,20.314,.15,25.872l-5.668,14.102c19.321,15.047,44.242-1.722,44.242-1.722-.869-2.657-3.864-8.063-4.256-10.66,.284-3.312,1.213-5.488,2.616-11.288,.271-1.12,3.768-14.58,4.238-15.668Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.665,322.844s-7.485,.536-7.485-3.755,9.66-49.885,10.73-57.663c1.07-7.778,6.122-48.009,6.122-48.009,1.695-2,5.048-3.017,8.434-4.014l-17.802,113.442Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.665,322.844s-7.485,.536-7.485-3.755,9.66-49.885,10.73-57.663c1.07-7.778,6.122-48.009,6.122-48.009,1.695-2,5.048-3.017,8.434-4.014l-17.802,113.442Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.048,247.014s-7.417-3.919-7.978-5.601c-.561-1.683-1.337-6.185,3.815-8.252,1.711-.686,4.722,.859,4.722,.859v12.219l-.559,.775Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.9,208.306s-5.293,6.096-6.675,14.339-3.07,103.725-2.763,104.8c.307,1.075,29.013-.614,30.548-3.531,1.535-2.917-4.452-37.916-6.294-44.671-1.842-6.754-4.799-10.126-5.76-15.504-.98-5.481,4.803-50.321,4.525-48.154,.456-.516-8.059-6.73-13.581-7.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,208.306s-5.293,6.096-6.675,14.339-3.07,103.725-2.763,104.8c.307,1.075,29.013-.614,30.548-3.531,1.535-2.917-4.452-37.916-6.294-44.671-1.842-6.754-4.799-10.126-5.76-15.504-.98-5.481,4.803-50.321,4.525-48.154,.456-.516-8.059-6.73-13.581-7.28Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.828,
    y: 219.82,
    width: 29.612,
    height: 41.606,
    rx: 3.229,
    ry: 3.229,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.453 248.473 378.863 247.171 382.136 241.723 383.637 242.468 380.453 248.473",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.617,239.019c-1.153-1.782-1.853-2.219-3.315-3.121l-.013,2.732c-.881-.026-8.079-3.943-9.305-3.84-1.226,.102-.381,1.071-.381,1.071,0,0-1.595-.921-2.132-.388-.139,.138-.239,.686,.422,1.22,1.488,1.201,4.739,3.56,4.739,3.56-.184-.139-4.405-2.764-5.089-3.075-.893-.406-1.522-.142-1.74,.384-.311,.748,4.812,4.181,4.927,4.477,0,0-2.883-2.075-3.826-1.624-.943,.451,.801,1.857,2.574,2.804,1.625,.868,4.586,2.997,6.324,3.719,2.141,.89,3.779,1.007,5.37-.476,1.59-1.483,2.033-3.157,2.033-3.157,0,0,.567-2.503-.586-4.285Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.482,215.585c-5.082-4.65-9.223-.78-11.292,1.949-3.314,4.396-1.103,16.703-1.103,16.703l.024,.01c.091,6.024,.107,13.766-.178,14.131l-18.47-7.466-6.022,11.357s6.784,3.125,17.218,7.782c10.944,4.885,17.003,4.221,19.583-3.375,1.272-3.746,1.585-10.8,1.602-16.52h.001s1.801-21.686-1.363-24.571Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.482,215.585c-5.082-4.65-9.223-.78-11.292,1.949-3.314,4.396-1.103,16.703-1.103,16.703l.024,.01c.091,6.024,.107,13.766-.178,14.131l-18.47-7.466-6.022,11.357s6.784,3.125,17.218,7.782c10.944,4.885,17.003,4.221,19.583-3.375,1.272-3.746,1.585-10.8,1.602-16.52h.001s1.801-21.686-1.363-24.571Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 358.005,
    y: 217.446,
    width: 12.274,
    height: 3.455,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.125,176.87c4.101,1.518,14.311,18.652,7.818,25.18-6.493,6.528-28.193,3.925-31.327-2.954-1.845-3.994-1.3-8.685,1.412-12.149,0,0-4.696-15.617,3.613-18.814s14.889,2.303,14.889,2.303c0,0-.506,4.917,3.595,6.435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.014,193.662l-4.733,1.125-.003,.003-4.518,2.255c-.002,.068-.004,.137-.006,.214l1.137,6.749c.22,2.014-1.845,3.682-3.172,4.161-.743,.63-.717,6.102,3.23,10.635,1.276,1.465,3.2-1.069,4.661-2.457,5.989-6.305,6.567-9.415,6.567-9.415-2.413-2.014-3.166-8.78-3.163-13.271Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.649,183.634c-1.52,7.875-1.988,11.227-6.45,14.951-6.718,5.59-15.84,2.441-16.688-5.643-.707-7.269,1.854-18.909,9.879-21.409,8.025-2.501,14.775,4.216,13.26,12.101Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.764,182.628c-.103,.005-.204-.032-.277-.11-1.135-1.227-2.557-.916-2.574-.913-.211,.047-.409-.084-.438-.298-.029-.214,.121-.426,.334-.476,.074-.017,1.859-.408,3.268,1.115,.14,.152,.122,.403-.04,.561-.079,.076-.177,.116-.273,.121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.643,180.728c-.078-.032-.14-.097-.168-.188-.057-.187,.051-.412,.242-.503,1.916-.912,3.206-.038,3.26,0,.153,.107,.172,.337,.043,.515-.128,.178-.356,.236-.509,.13-.05-.035-1.061-.696-2.585,.029-.099,.047-.2,.049-.283,.014Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.134,184.684s-1.507,2.924-3.078,4.705c-.275,.311-.162,.8,.209,.967,.957,.43,2.141,.176,2.141,.176l.727-5.848Z",
    style: {
      fill: "#ef8535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.348,183.981c.012-.011,.023-.012,.035-.024l-1.799-.556s.38,.604,.896,.785c-.269,.269-.479,.704-.545,1.206-.111,.847,.225,1.553,.752,1.577,.527,.024,1.045-.644,1.156-1.491,.092-.697-.123-1.293-.495-1.497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.381,183.442l.008-.006-1.799-.557s.43,.679,.995,.809c-.263,.261-.469,.678-.533,1.159-.109,.821,.228,1.506,.753,1.529,.525,.024,1.04-.623,1.15-1.444,.097-.723-.154-1.339-.574-1.492Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.551,192.779c.527,.834,1.15,2.451,1.15,2.451,.157-.033,.315-.066,.47-.107,2.125-.501,2.959-1.434,3.239-2.317,.152-.483,.131-.956,.066-1.33-.071-.433-.221-.724-.221-.724-.981,.937-2.929,1.557-3.983,1.844-.44,.125-.722,.182-.722,.182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.273,192.597l.358,.713c2-.477,3.35-1.081,3.846-1.834-.071-.433-.221-.724-.221-.724-.981,.937-2.929,1.557-3.983,1.844Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.172,195.123c2.125-.501,2.959-1.434,3.239-2.317-.718,.199-1.563,.518-2.259,1.023-.533,.384-.819,.851-.981,1.294Z",
    style: {
      fill: "#fd504e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.061,196.562c6.871-5.414,6.991-25.941-5.967-26.081-12.957-.14-11.951,13.361-11.951,13.361,1.255-15.12,15.965-8.517,15.965-8.517-.692,4.756,1.155,11.432,1.155,11.432,2.051,3.96,.801,9.822,.798,9.805Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.206,169.287c9.375,2.793,7.389,9.13,7.389,9.13,0,0,7.805,9.229,7.159,16.376-.645,7.147-10.76,10.265-10.76,10.265,9.929-3.515,8.622-15.182-2.929-18.377-9.557-2.641-8.661-12.908-8.661-12.908,0,0,2.549-6.035,7.803-4.487Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.621,182.21c-.082,0-.162-.04-.21-.114-4.193-6.477-1.097-9.951-.963-10.096,.094-.101,.252-.107,.353-.014,.102,.093,.108,.251,.015,.353-.122,.134-2.954,3.353,1.016,9.485,.075,.116,.042,.271-.074,.346-.042,.027-.089,.04-.136,.04Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.728,202.299c-.058,0-.116-.02-.163-.061-2.325-2.003-3.544-4.315-3.624-6.873-.154-4.958,3.975-9.048,4.15-9.219,.099-.096,.257-.095,.354,.004,.097,.099,.095,.257-.004,.354-.042,.041-4.148,4.112-4,8.849,.076,2.411,1.237,4.6,3.45,6.507,.104,.09,.116,.248,.026,.353-.05,.058-.119,.087-.189,.087Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.077,188.75c-1.085,1.585-2.708,2.518-4.146,2.78-2.163,.394-2.967-3.097-2.063-5.179,.814-1.875,3.002-3.007,5.028-2.453,1.996,.546,2.422,3.04,1.182,4.852Z",
    style: {
      fill: "#ffaf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.638,188.277c-.012,0-.024,0-.038-.003-.136-.021-.229-.148-.209-.285,.125-.825,.58-1.589,1.248-2.096,.669-.507,1.525-.733,2.347-.629,.137,.018,.233,.144,.216,.28s-.148,.233-.28,.216c-.697-.091-1.416,.103-1.979,.531-.565,.429-.95,1.075-1.057,1.772-.019,.124-.125,.212-.247,.212Z",
    style: {
      opacity: 0.2
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplecreatingrobotRafiki);
export default __webpack_public_path__ + "static/media/people creating robot-rafiki.d84a2377167c85fd92f707ba1e8c6b4b.svg";
export { ForwardRef as ReactComponent };